import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2c15e916&vue3"
import script from "./header.vue?vue&type=script&lang=js&vue3"
export * from "./header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports